import moment, { Moment } from 'moment'
import { isAdminLabelAA } from '../../../../../services/AccountService'
import {
  dataEditReportStatuses,
  getCanAddPicsAA,
} from '../../../consts/request-body-data'
import { RequestType } from '../../../types/Request.type'
import { CustomFileType } from '../content/DrawerContentInstallation'
import { getReportPeriodError } from '../elements/InstallationDatePicker'
import { changeInstallationDataLableAA } from './getDefaultDrawerState'

type ParamsType = {
  installationDate?: string
  equipmentId?: string
  updateComment?: string
}

export const getInstallationDrawerState = (
  request: RequestType,
  installationDate: string | Moment | null,
  installationId: string | null,
  files: CustomFileType[] | null,
  comment: string,
) => {
  const state = {
    canChangeInstallationDataLabelAA:
      isAdminLabelAA() &&
      changeInstallationDataLableAA.includes(request.reportStatus!),
    isSameInstallationDate:
      moment(installationDate).format() ===
      moment(request.installationDate).format(),
    isSameInstallationId: installationId === request.equipmentId,
    canUploadImages:
      (dataEditReportStatuses.includes(request.reportStatus!) ||
        getCanAddPicsAA(request)) &&
      isAdminLabelAA(),
    shouldShowCommentField: false,
    canChangeInstallationData: false,
    disableSaveBtnById: true,
    disableSaveBtnByDate: false,
    disableSaveBtnByComment: false,
    disableSaveBtnByFile: false,
    disableSaveBtn: false,
    dateError: false as boolean | string,
    reportPeriodError: false as boolean | string,
  }

  state.shouldShowCommentField =
    state.canChangeInstallationDataLabelAA &&
    (!state.isSameInstallationId ||
      !state.isSameInstallationDate ||
      files?.length)

  state.canChangeInstallationData =
    [6, 13].includes(request.status) || state.canChangeInstallationDataLabelAA

  state.disableSaveBtnById =
    state.isSameInstallationId || !getIsEquipmentIdCorrect(installationId)

  state.disableSaveBtnByDate =
    !!installationDate &&
    state.isSameInstallationDate &&
    state.canChangeInstallationData

  state.disableSaveBtnByComment =
    state.canChangeInstallationDataLabelAA && !comment

  state.disableSaveBtnByFile =
    (!files || !files?.length) && state.canUploadImages

  state.dateError =
    (!moment(installationDate).isValid() ||
      moment(installationDate).isAfter(moment())) &&
    'Введите корректную дату'
  state.reportPeriodError =
    getReportPeriodError(request, installationDate) &&
    state.canChangeInstallationData

  // todo: зарефакторить а то хотела как лучше в итоге как всегда -_-
  state.disableSaveBtn =
    (state.disableSaveBtnById &&
      !!state.disableSaveBtnByDate &&
      state.disableSaveBtnByFile) ||
    state.disableSaveBtnByComment ||
    !!state.dateError ||
    state.reportPeriodError

  return state
}

export const getIsEquipmentIdCorrect = (
  installationId: string | null | undefined,
) =>
  installationId?.length === 14 &&
  Number(installationId?.slice(0, 2)) ===
    Number(
      installationId
        ?.slice(2, 14)
        .split('')
        .reduce((acc: any, el: any) => {
          return +acc + +el
        }, 0),
    )

export const getParams = (
  state: ReturnType<typeof getInstallationDrawerState>,
  newId: string | null,
  newDate: string | Moment | null,
  comment: string,
): { params: ParamsType; message: string } => {
  let message = ''
  const params: ParamsType = {}
  if (newId && !state.isSameInstallationId) {
    params.equipmentId = newId
    message = 'Id оборудования обновлён'
  }
  if (newDate && !state.isSameInstallationDate) {
    params.installationDate = moment(newDate).local(true).format()
    message = 'Данные оборудования обновлены'
  }

  if (state.shouldShowCommentField) {
    params.updateComment = comment
  }

  if (!message) {
    message = 'Заявка обновлена'
  }

  return { params, message }
}
